// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.manage-payments-container {
    width: 85%;
    margin: 3rem auto;
    padding-block: 2rem;
    padding-inline: 2.5rem;
    border-radius: var(--radius);
    background-color: var(--clr-white);
    box-shadow: var(--shadow-2);
    border: 2px solid var(--clr-primary-4);
    font-family: var(--ff-primary);
    box-sizing: border-box;
  }
  
  .manage-payments-heading {
    font-size: 1.75rem;
    margin-bottom: 2rem;
    color: var(--clr-grey-1);
    text-align: center;
    letter-spacing: var(--letterSpacing);
    font-weight: 600;
  }
  
  .manage-payments-sections {
    display: flex;
    gap: 2rem;
    align-items: flex-start;
    justify-content: space-between;
  }
  
  /* Section boxes with visual separation */
  .section-box {
    flex: 1 1;
    background-color: var(--clr-grey-8);
    padding: 1.5rem;
    border-radius: var(--radius);
    border: 1px solid var(--clr-primary-5);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  
  /* Divider between sections */
  .section-box:not(:last-child) {
    border-right: 2px solid var(--clr-grey-8);
  }
  
  /* Wrap multiple saved cards in a clean stacked layout */
  .saved-card-list {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    max-height: 350px;
    overflow-y: auto;
    padding-right: 0.5rem;
  }
  
  .saved-card-list::-webkit-scrollbar {
    width: 6px;
  }
  
  .saved-card-list::-webkit-scrollbar-thumb {
    background-color: var(--clr-grey-5);
    border-radius: 10px;
  }
  
  
  /* Individual card entry */
  .saved-card-details {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 0.75rem 1rem;
    background-color: var(--clr-white);
    border-radius: var(--radius);
    box-shadow: var(--shadow-1);
    border-left: 4px solid var(--clr-primary-4);
  }
  
  /* Card icon bubble */
  .card-icon {
    width: 40px;
    height: 40px;
    background-color: var(--clr-primary-10);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    font-size: 1.2rem;
  }
  
  /* Text inside card block */
  .card-details-text {
    display: flex;
    flex-direction: column;
  }
  
  .card-brand {
    font-weight: 500;
    color: var(--clr-grey-1);
  }
  
  .card-expiry {
    font-size: var(--small-text);
    color: var(--clr-grey-4);
  }
  
  /* Spinner container */
  .card-spinner-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100px;
  }
  
  
  /* .placeholder-message {
    text-align: center;
    color: var(--clr-grey-3);
    font-size: var(--small-text);
  } */
  
  /* Placeholder */
  .placeholder-message {
    font-size: var(--small-text);
    color: var(--clr-grey-3);
    line-height: 1.7;
    background-color: var(--clr-grey-9);
    border: 1px dashed var(--clr-grey-5);
    border-radius: var(--radius);
    padding: 1rem;
    text-align: center;
  }
  
  /* Card Entry */
  .card-entry-section {
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
  }
  
  .card-entry-section h3 {
    font-size: 1.1rem;
    color: var(--clr-grey-2);
    margin-bottom: 0.5rem;
    font-weight: 500;
  }
  
  /* .card-element-wrapper {
    padding: 1rem;
    border: 1px solid var(--clr-grey-6);
    border-radius: var(--radius);
    background-color: var(--clr-white);
  } */
  
  .card-element-wrapper {
    padding: 1rem;
    border: 1px solid var(--clr-grey-6);
    border-radius: var(--radius);
    background-color: var(--clr-white);
    transition: var(--transition);
    box-shadow: var(--shadow-1);
  }
  
  .card-element-wrapper:hover {
    border-color: var(--clr-primary-4);
    box-shadow: 0 0 0 2px var(--clr-primary-8);
  }
  
  .card-element-wrapper:focus-within {
    border-color: var(--clr-primary-5);
    box-shadow: 0 0 0 2px var(--clr-primary-5);
  }
  
  .save-card-button {
    background-color: var(--clr-primary-5);
    color: var(--clr-white);
    border: none;
    border-radius: var(--radius);
    padding: 0.75rem 1.5rem;
    font-size: 1rem;
    font-weight: 500;
    cursor: pointer;
    transition: var(--transition);
    letter-spacing: var(--letterSpacing);
    align-self: flex-start;
  }
  
  .save-card-button:hover {
    background-color: var(--clr-primary-4);
  }
  
  /* Responsive */
  @media screen and (max-width: 768px) {
    .manage-payments-container {
      width: 95%;
      padding: 1.5rem;
    }
  
    .manage-payments-heading {
      font-size: 1.5rem;
    }
  
    .manage-payments-sections {
      flex-direction: column;
      gap: 1.5rem;
    }
    
    .section-box {
      width: 100%;
    }
    
    .section-box:not(:last-child) {
      border-right: none;
    }
  
    .save-card-button {
      width: 100%;
      text-align: center;
    }
  }
  
  /* .page-wrapper {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  } */

  .page-wrapper {
    /* background-color: var(--clr-grey-7); */
    padding: 2rem 1rem;
    min-height: 75vh;
    overflow-x: hidden; 
    box-sizing: border-box;
    margin: 1rem;
    padding: 10px;
    border: 2px dotted var(--clr-primary-3);
  }
  
  
  .info-banner {
    background-color: var(--clr-grey-9);
    border-left: 5px solid var(--clr-primary-5);
    border-radius: var(--radius);
    box-shadow: var(--shadow-2);
    padding: 2rem 2.5rem;
    margin: 0 auto 2rem auto;
    max-width: 960px;
    color: var(--clr-grey-1);
    line-height: 1.7;
    font-family: var(--ff-primary);
    transition: background-color 0.3s ease;
  }
  
  .info-banner h1 {
    font-size: 1.85rem;
    font-weight: 700;
    margin-bottom: 1rem;
    /* color: var(--clr-primary-8); */
    letter-spacing: 0.5px;
    text-align: center;
  }
  
  
  .info-banner p {
    font-size: 1rem;
    margin-bottom: 0.75rem;
    color: var(--clr-grey-3);
  }
  
  /*Responsive */
  @media screen and (max-width: 768px) {
    .info-banner {
      padding: 1.5rem 1.25rem;
    }
  
    .info-banner h1 {
      font-size: 1.5rem;
    }
  
    .info-banner p {
      font-size: 0.95rem;
    }
  }
  
  
  @media screen and (max-width: 480px) {
    .info-banner {
      padding: 1rem 0.75rem;
      border-left: 3px solid var(--clr-primary-4);
    }
  
    .info-banner h1 {
      font-size: 1.25rem;
    }
  
    .info-banner p {
      font-size: 0.85rem;
    }
  }

  
  .main-content {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  
  .saved-card-details {
    display: flex;
    align-items: center;
    gap: 1.25rem;
    padding: 1rem;
    border-radius: var(--radius);
    background-color: var(--clr-white);
    box-shadow: var(--shadow-1);
    transition: var(--transition);
  }
  
  .card-icon {
    width: 48px;
    height: 48px;
    font-size: 1.5rem;
    background-color: var(--clr-primary-6);
    color: var(--clr-white);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: var(--shadow-1);
    flex-shrink: 0;
  }
  
  .card-details-text {
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: var(--small-text);
    color: var(--clr-grey-2);
  }
  
  .card-brand {
    font-weight: 600;
    font-size: 1rem;
    color: var(--clr-grey-1);
    margin-bottom: 0.2rem;
  }
  
  .card-expiry {
    font-size: 0.9rem;
    color: var(--clr-grey-4);
  }
  
  .placeholder-message {
    font-size: 0.95rem;
    color: var(--clr-grey-4);
    background-color: var(--clr-grey-10);
    border-left: 4px solid var(--clr-primary-4);
    padding: 1rem 1.25rem;
    border-radius: var(--radius);
    line-height: 1.6;
  }
  
  .card-spinner-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100px;
    width: 100%;
  }
  
  .card-loading-spinner {
    width: 32px;
    height: 32px;
    border: 3px solid var(--clr-primary-6);
    border-top: 3px solid transparent;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
  }
  
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
  
  .card-saved-banner {
    margin-top: 1rem;
    background-color: var(--green-light);
    color: var(--green-dark);
    padding: 0.75rem 1.25rem;
    border-left: 4px solid var(--green-dark);
    border-radius: var(--radius);
    font-size: var(--small-text);
    font-weight: 500;
    animation: fadeIn 0.4s ease-in-out;
  }
  
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(4px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  .cvv-toggle-button {
    margin-left: 1rem;
    background: none;
    border: none;
    color: var(--clr-primary-5);
    cursor: pointer;
    font-weight: 500;
    transition: var(--transition);
  }
  
  .cvv-toggle-button:hover {
    color: var(--clr-primary-3);
  }
  
  .meta-line {
    font-size: 0.8rem;
    color: var(--clr-grey-4);
    margin-top: 0.75rem;
  }


  .remove-card-btn {
    margin-left: auto;
    background-color: var(--red-light);
    border: 1px solid var(--red-dark);
    color: var(--red-dark);
    padding: 0.4rem 0.75rem;
    border-radius: var(--radius);
    font-size: 0.85rem;
    cursor: pointer;
    transition: background-color 0.2s ease;
  }
  
  .remove-card-btn:hover {
    background-color: #ffe5e5;
  }
  
  .invoice-estimation-box {
    margin-top: 2rem;
    padding: 1.5rem;
    border: 1px solid var(--clr-grey-4);
    border-radius: var(--radius);
    background-color: var(--clr-grey-1);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  }
  
  .invoice-estimation-box h3 {
    font-size: 1.2rem;
    font-weight: 600;
    margin-bottom: 1rem;
    color: var(--clr-primary-7);
  }
  
  .invoice-summary-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
    font-size: 0.95rem;
    line-height: 1.6;
  }
  
  .invoice-summary-grid .label {
    font-weight: 500;
    color: var(--clr-grey-6);
  }
  
  .invoice-summary-grid .value {
    font-weight: 600;
    color: var(--clr-primary-9);
  }
  
  .invoice-total-highlight {
    margin-top: 1.5rem;
    font-size: 1.1rem;
    font-weight: 700;
    color: var(--clr-primary-8);
  }
  
  .amount-breakup {
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
    font-size: 0.95rem;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/ManagePaymentsSection/managePaymentsStyles.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,4BAA4B;IAC5B,kCAAkC;IAClC,2BAA2B;IAC3B,sCAAsC;IACtC,8BAA8B;IAC9B,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,wBAAwB;IACxB,kBAAkB;IAClB,oCAAoC;IACpC,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,8BAA8B;EAChC;;EAEA,yCAAyC;EACzC;IACE,SAAO;IACP,mCAAmC;IACnC,eAAe;IACf,4BAA4B;IAC5B,sCAAsC;IACtC,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;EAChC;;EAEA,6BAA6B;EAC7B;IACE,yCAAyC;EAC3C;;EAEA,wDAAwD;EACxD;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,mCAAmC;IACnC,mBAAmB;EACrB;;;EAGA,0BAA0B;EAC1B;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,qBAAqB;IACrB,kCAAkC;IAClC,4BAA4B;IAC5B,2BAA2B;IAC3B,2CAA2C;EAC7C;;EAEA,qBAAqB;EACrB;IACE,WAAW;IACX,YAAY;IACZ,uCAAuC;IACvC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA,2BAA2B;EAC3B;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;IAC5B,wBAAwB;EAC1B;;EAEA,sBAAsB;EACtB;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;EACnB;;;EAGA;;;;KAIG;;EAEH,gBAAgB;EAChB;IACE,4BAA4B;IAC5B,wBAAwB;IACxB,gBAAgB;IAChB,mCAAmC;IACnC,oCAAoC;IACpC,4BAA4B;IAC5B,aAAa;IACb,kBAAkB;EACpB;;EAEA,eAAe;EACf;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;;;;;KAKG;;EAEH;IACE,aAAa;IACb,mCAAmC;IACnC,4BAA4B;IAC5B,kCAAkC;IAClC,6BAA6B;IAC7B,2BAA2B;EAC7B;;EAEA;IACE,kCAAkC;IAClC,0CAA0C;EAC5C;;EAEA;IACE,kCAAkC;IAClC,0CAA0C;EAC5C;;EAEA;IACE,sCAAsC;IACtC,uBAAuB;IACvB,YAAY;IACZ,4BAA4B;IAC5B,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,6BAA6B;IAC7B,oCAAoC;IACpC,sBAAsB;EACxB;;EAEA;IACE,sCAAsC;EACxC;;EAEA,eAAe;EACf;IACE;MACE,UAAU;MACV,eAAe;IACjB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,sBAAsB;MACtB,WAAW;IACb;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,WAAW;MACX,kBAAkB;IACpB;EACF;;EAEA;;;;KAIG;;EAEH;IACE,yCAAyC;IACzC,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,uCAAuC;EACzC;;;EAGA;IACE,mCAAmC;IACnC,2CAA2C;IAC3C,4BAA4B;IAC5B,2BAA2B;IAC3B,oBAAoB;IACpB,wBAAwB;IACxB,gBAAgB;IAChB,wBAAwB;IACxB,gBAAgB;IAChB,8BAA8B;IAC9B,sCAAsC;EACxC;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,iCAAiC;IACjC,qBAAqB;IACrB,kBAAkB;EACpB;;;EAGA;IACE,eAAe;IACf,sBAAsB;IACtB,wBAAwB;EAC1B;;EAEA,cAAc;EACd;IACE;MACE,uBAAuB;IACzB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;IACpB;EACF;;;EAGA;IACE;MACE,qBAAqB;MACrB,2CAA2C;IAC7C;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,kBAAkB;IACpB;EACF;;;EAGA;IACE,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,4BAA4B;IAC5B,kCAAkC;IAClC,2BAA2B;IAC3B,6BAA6B;EAC/B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,sCAAsC;IACtC,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;IAC3B,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;IAC5B,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,wBAAwB;IACxB,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;IAClB,wBAAwB;IACxB,oCAAoC;IACpC,2CAA2C;IAC3C,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,sCAAsC;IACtC,iCAAiC;IACjC,kBAAkB;IAClB,oCAAoC;EACtC;;EAEA;IACE;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE,gBAAgB;IAChB,oCAAoC;IACpC,wBAAwB;IACxB,wBAAwB;IACxB,wCAAwC;IACxC,4BAA4B;IAC5B,4BAA4B;IAC5B,gBAAgB;IAChB,kCAAkC;EACpC;;EAEA;IACE;MACE,UAAU;MACV,0BAA0B;IAC5B;IACA;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,6BAA6B;EAC/B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,mBAAmB;EACrB;;;EAGA;IACE,iBAAiB;IACjB,kCAAkC;IAClC,iCAAiC;IACjC,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;IAC5B,kBAAkB;IAClB,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,mCAAmC;IACnC,4BAA4B;IAC5B,mCAAmC;IACnC,yCAAyC;EAC3C;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;IAChB,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,kBAAkB;EACpB","sourcesContent":[".manage-payments-container {\n    width: 85%;\n    margin: 3rem auto;\n    padding-block: 2rem;\n    padding-inline: 2.5rem;\n    border-radius: var(--radius);\n    background-color: var(--clr-white);\n    box-shadow: var(--shadow-2);\n    border: 2px solid var(--clr-primary-4);\n    font-family: var(--ff-primary);\n    box-sizing: border-box;\n  }\n  \n  .manage-payments-heading {\n    font-size: 1.75rem;\n    margin-bottom: 2rem;\n    color: var(--clr-grey-1);\n    text-align: center;\n    letter-spacing: var(--letterSpacing);\n    font-weight: 600;\n  }\n  \n  .manage-payments-sections {\n    display: flex;\n    gap: 2rem;\n    align-items: flex-start;\n    justify-content: space-between;\n  }\n  \n  /* Section boxes with visual separation */\n  .section-box {\n    flex: 1;\n    background-color: var(--clr-grey-8);\n    padding: 1.5rem;\n    border-radius: var(--radius);\n    border: 1px solid var(--clr-primary-5);\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n  }\n  \n  /* Divider between sections */\n  .section-box:not(:last-child) {\n    border-right: 2px solid var(--clr-grey-8);\n  }\n  \n  /* Wrap multiple saved cards in a clean stacked layout */\n  .saved-card-list {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    max-height: 350px;\n    overflow-y: auto;\n    padding-right: 0.5rem;\n  }\n  \n  .saved-card-list::-webkit-scrollbar {\n    width: 6px;\n  }\n  \n  .saved-card-list::-webkit-scrollbar-thumb {\n    background-color: var(--clr-grey-5);\n    border-radius: 10px;\n  }\n  \n  \n  /* Individual card entry */\n  .saved-card-details {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    padding: 0.75rem 1rem;\n    background-color: var(--clr-white);\n    border-radius: var(--radius);\n    box-shadow: var(--shadow-1);\n    border-left: 4px solid var(--clr-primary-4);\n  }\n  \n  /* Card icon bubble */\n  .card-icon {\n    width: 40px;\n    height: 40px;\n    background-color: var(--clr-primary-10);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    font-size: 1.2rem;\n  }\n  \n  /* Text inside card block */\n  .card-details-text {\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .card-brand {\n    font-weight: 500;\n    color: var(--clr-grey-1);\n  }\n  \n  .card-expiry {\n    font-size: var(--small-text);\n    color: var(--clr-grey-4);\n  }\n  \n  /* Spinner container */\n  .card-spinner-wrapper {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 100px;\n  }\n  \n  \n  /* .placeholder-message {\n    text-align: center;\n    color: var(--clr-grey-3);\n    font-size: var(--small-text);\n  } */\n  \n  /* Placeholder */\n  .placeholder-message {\n    font-size: var(--small-text);\n    color: var(--clr-grey-3);\n    line-height: 1.7;\n    background-color: var(--clr-grey-9);\n    border: 1px dashed var(--clr-grey-5);\n    border-radius: var(--radius);\n    padding: 1rem;\n    text-align: center;\n  }\n  \n  /* Card Entry */\n  .card-entry-section {\n    display: flex;\n    flex-direction: column;\n    gap: 1.25rem;\n  }\n  \n  .card-entry-section h3 {\n    font-size: 1.1rem;\n    color: var(--clr-grey-2);\n    margin-bottom: 0.5rem;\n    font-weight: 500;\n  }\n  \n  /* .card-element-wrapper {\n    padding: 1rem;\n    border: 1px solid var(--clr-grey-6);\n    border-radius: var(--radius);\n    background-color: var(--clr-white);\n  } */\n  \n  .card-element-wrapper {\n    padding: 1rem;\n    border: 1px solid var(--clr-grey-6);\n    border-radius: var(--radius);\n    background-color: var(--clr-white);\n    transition: var(--transition);\n    box-shadow: var(--shadow-1);\n  }\n  \n  .card-element-wrapper:hover {\n    border-color: var(--clr-primary-4);\n    box-shadow: 0 0 0 2px var(--clr-primary-8);\n  }\n  \n  .card-element-wrapper:focus-within {\n    border-color: var(--clr-primary-5);\n    box-shadow: 0 0 0 2px var(--clr-primary-5);\n  }\n  \n  .save-card-button {\n    background-color: var(--clr-primary-5);\n    color: var(--clr-white);\n    border: none;\n    border-radius: var(--radius);\n    padding: 0.75rem 1.5rem;\n    font-size: 1rem;\n    font-weight: 500;\n    cursor: pointer;\n    transition: var(--transition);\n    letter-spacing: var(--letterSpacing);\n    align-self: flex-start;\n  }\n  \n  .save-card-button:hover {\n    background-color: var(--clr-primary-4);\n  }\n  \n  /* Responsive */\n  @media screen and (max-width: 768px) {\n    .manage-payments-container {\n      width: 95%;\n      padding: 1.5rem;\n    }\n  \n    .manage-payments-heading {\n      font-size: 1.5rem;\n    }\n  \n    .manage-payments-sections {\n      flex-direction: column;\n      gap: 1.5rem;\n    }\n    \n    .section-box {\n      width: 100%;\n    }\n    \n    .section-box:not(:last-child) {\n      border-right: none;\n    }\n  \n    .save-card-button {\n      width: 100%;\n      text-align: center;\n    }\n  }\n  \n  /* .page-wrapper {\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n  } */\n\n  .page-wrapper {\n    /* background-color: var(--clr-grey-7); */\n    padding: 2rem 1rem;\n    min-height: 75vh;\n    overflow-x: hidden; \n    box-sizing: border-box;\n    margin: 1rem;\n    padding: 10px;\n    border: 2px dotted var(--clr-primary-3);\n  }\n  \n  \n  .info-banner {\n    background-color: var(--clr-grey-9);\n    border-left: 5px solid var(--clr-primary-5);\n    border-radius: var(--radius);\n    box-shadow: var(--shadow-2);\n    padding: 2rem 2.5rem;\n    margin: 0 auto 2rem auto;\n    max-width: 960px;\n    color: var(--clr-grey-1);\n    line-height: 1.7;\n    font-family: var(--ff-primary);\n    transition: background-color 0.3s ease;\n  }\n  \n  .info-banner h1 {\n    font-size: 1.85rem;\n    font-weight: 700;\n    margin-bottom: 1rem;\n    /* color: var(--clr-primary-8); */\n    letter-spacing: 0.5px;\n    text-align: center;\n  }\n  \n  \n  .info-banner p {\n    font-size: 1rem;\n    margin-bottom: 0.75rem;\n    color: var(--clr-grey-3);\n  }\n  \n  /*Responsive */\n  @media screen and (max-width: 768px) {\n    .info-banner {\n      padding: 1.5rem 1.25rem;\n    }\n  \n    .info-banner h1 {\n      font-size: 1.5rem;\n    }\n  \n    .info-banner p {\n      font-size: 0.95rem;\n    }\n  }\n  \n  \n  @media screen and (max-width: 480px) {\n    .info-banner {\n      padding: 1rem 0.75rem;\n      border-left: 3px solid var(--clr-primary-4);\n    }\n  \n    .info-banner h1 {\n      font-size: 1.25rem;\n    }\n  \n    .info-banner p {\n      font-size: 0.85rem;\n    }\n  }\n\n  \n  .main-content {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n  }\n  \n  .saved-card-details {\n    display: flex;\n    align-items: center;\n    gap: 1.25rem;\n    padding: 1rem;\n    border-radius: var(--radius);\n    background-color: var(--clr-white);\n    box-shadow: var(--shadow-1);\n    transition: var(--transition);\n  }\n  \n  .card-icon {\n    width: 48px;\n    height: 48px;\n    font-size: 1.5rem;\n    background-color: var(--clr-primary-6);\n    color: var(--clr-white);\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: var(--shadow-1);\n    flex-shrink: 0;\n  }\n  \n  .card-details-text {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    font-size: var(--small-text);\n    color: var(--clr-grey-2);\n  }\n  \n  .card-brand {\n    font-weight: 600;\n    font-size: 1rem;\n    color: var(--clr-grey-1);\n    margin-bottom: 0.2rem;\n  }\n  \n  .card-expiry {\n    font-size: 0.9rem;\n    color: var(--clr-grey-4);\n  }\n  \n  .placeholder-message {\n    font-size: 0.95rem;\n    color: var(--clr-grey-4);\n    background-color: var(--clr-grey-10);\n    border-left: 4px solid var(--clr-primary-4);\n    padding: 1rem 1.25rem;\n    border-radius: var(--radius);\n    line-height: 1.6;\n  }\n  \n  .card-spinner-wrapper {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 100px;\n    width: 100%;\n  }\n  \n  .card-loading-spinner {\n    width: 32px;\n    height: 32px;\n    border: 3px solid var(--clr-primary-6);\n    border-top: 3px solid transparent;\n    border-radius: 50%;\n    animation: spin 0.8s linear infinite;\n  }\n  \n  @keyframes spin {\n    to {\n      transform: rotate(360deg);\n    }\n  }\n  \n  .card-saved-banner {\n    margin-top: 1rem;\n    background-color: var(--green-light);\n    color: var(--green-dark);\n    padding: 0.75rem 1.25rem;\n    border-left: 4px solid var(--green-dark);\n    border-radius: var(--radius);\n    font-size: var(--small-text);\n    font-weight: 500;\n    animation: fadeIn 0.4s ease-in-out;\n  }\n  \n  @keyframes fadeIn {\n    from {\n      opacity: 0;\n      transform: translateY(4px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n  \n  .cvv-toggle-button {\n    margin-left: 1rem;\n    background: none;\n    border: none;\n    color: var(--clr-primary-5);\n    cursor: pointer;\n    font-weight: 500;\n    transition: var(--transition);\n  }\n  \n  .cvv-toggle-button:hover {\n    color: var(--clr-primary-3);\n  }\n  \n  .meta-line {\n    font-size: 0.8rem;\n    color: var(--clr-grey-4);\n    margin-top: 0.75rem;\n  }\n\n\n  .remove-card-btn {\n    margin-left: auto;\n    background-color: var(--red-light);\n    border: 1px solid var(--red-dark);\n    color: var(--red-dark);\n    padding: 0.4rem 0.75rem;\n    border-radius: var(--radius);\n    font-size: 0.85rem;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n  }\n  \n  .remove-card-btn:hover {\n    background-color: #ffe5e5;\n  }\n  \n  .invoice-estimation-box {\n    margin-top: 2rem;\n    padding: 1.5rem;\n    border: 1px solid var(--clr-grey-4);\n    border-radius: var(--radius);\n    background-color: var(--clr-grey-1);\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n  }\n  \n  .invoice-estimation-box h3 {\n    font-size: 1.2rem;\n    font-weight: 600;\n    margin-bottom: 1rem;\n    color: var(--clr-primary-7);\n  }\n  \n  .invoice-summary-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 1rem;\n    font-size: 0.95rem;\n    line-height: 1.6;\n  }\n  \n  .invoice-summary-grid .label {\n    font-weight: 500;\n    color: var(--clr-grey-6);\n  }\n  \n  .invoice-summary-grid .value {\n    font-weight: 600;\n    color: var(--clr-primary-9);\n  }\n  \n  .invoice-total-highlight {\n    margin-top: 1.5rem;\n    font-size: 1.1rem;\n    font-weight: 700;\n    color: var(--clr-primary-8);\n  }\n  \n  .amount-breakup {\n    display: flex;\n    flex-direction: column;\n    gap: 0.2rem;\n    font-size: 0.95rem;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
